import { Button } from "@/components/ui/button";
import Text from "@/components/Text";
import {
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { createFavoriteListAndAddRestaurantToFavoriteList } from "@/store/userFavoriteListState";
import { zodResolver } from "@hookform/resolvers/zod";
import type { FC } from "react";
import { useForm } from "react-hook-form";
import z from "zod";
import { useTranslation } from "react-i18next";

const formSchema = z.object({
  favoriteListName: z
    .string()
    .min(1, "Le nom de la liste est requis")
    .max(50, "Le nom de la liste doit contenir moins de 50 caractères"),
});

type Props = {
  onClose: () => void;
  isLoading: boolean;
  restaurantsId: string[];
};

const CreateFavoriteList: FC<Props> = ({
  onClose,
  isLoading,
  restaurantsId,
}) => {
  const { t } = useTranslation();
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
  });

  const handleSubmit = (values: z.infer<typeof formSchema>) => {
    createFavoriteListAndAddRestaurantToFavoriteList({
      favoriteListName: values.favoriteListName,
      restaurantsId: restaurantsId,
    });
  };

  return (
    <>
      <DialogHeader>
        <DialogTitle>
          <Text fontSize={20} fontWeight={600}>
            {t("create_favorite_list")}
          </Text>
        </DialogTitle>
      </DialogHeader>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <DialogDescription>
            <FormField
              control={form.control}
              name="favoriteListName"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{t("name")}</FormLabel>
                  <FormControl>
                    <Input
                      {...field}
                      placeholder={t("placeholder_favorite_name")}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </DialogDescription>

          <DialogFooter className="w-[full] flex items-center mt-[32px]">
            <Button
              type="button"
              variant="secondaryFilled"
              onClick={() => onClose()}
              className="w-[50%]"
            >
              {t("cancel")}
            </Button>
            <Button className="w-[50%]" disabled={isLoading}>
              {t("create")}
            </Button>
          </DialogFooter>
        </form>
      </Form>
    </>
  );
};

export default CreateFavoriteList;
